// extracted by mini-css-extract-plugin
export var actions = "_13-0";
export var actionsContainer = "_13-6";
export var border = "_13-1";
export var childFullHeight = "_13-d";
export var collapse = "_13-2";
export var content = "_13-8";
export var contentChild = "_13-c";
export var fullscreen = "_13-a";
export var headerContainer = "_13-3";
export var headerRow = "_13-5";
export var hidePadding = "_13-9";
export var noScrollX = "_13-e";
export var noScrollY = "_13-f";
export var optOutTopPadding = "_13-b";
export var pagePadding = "_13-7";
export var profile = "_13-g";
export var profileContainer = "_13-h";
export var profileImage = "_13-i";
export var profileMain = "_13-j";
export var profileSubtitle = "_13-l";
export var profileTitle = "_13-k";
export var tabsWrapper = "_13-4";
export var title = "_13-m";